enum EButtonVariant {
    Solid = "solid",
    SolidDark = "solidDark",
    Outlined = "outlined"
}

enum EButtonSize {
    Medium = "medium",
    Small = "small"
}

export { EButtonVariant, EButtonSize }
